(function () {
  if (window.__keyhavnSwatchHover) return;
  window.__keyhavnSwatchHover = true;

  function cardImageFrom(el) {
    var card = el.closest('.card-wrapper');
    return card ? card.querySelector('.card__media img') : null;
  }

  function preloadSwatchImages() {
    var links = document.querySelectorAll('.card-swatches__link[data-swatch-img]');
    for (var i = 0; i < links.length; i++) {
      var url = links[i].getAttribute('data-swatch-img');
      if (url) {
        var preload = new Image();
        preload.src = url;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preloadSwatchImages);
  } else {
    preloadSwatchImages();
  }

  document.addEventListener('mouseover', function (event) {
    var link = event.target.closest('.card-swatches__link[data-swatch-img]');
    if (!link) return;
    var img = cardImageFrom(link);
    if (!img) return;
    if (typeof img.dataset.khOriginalSrc === 'undefined') {
      img.dataset.khOriginalSrc = img.getAttribute('src') || '';
      img.dataset.khOriginalSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', '');
    img.setAttribute('src', link.getAttribute('data-swatch-img'));
  });

  document.addEventListener('mouseout', function (event) {
    var list = event.target.closest('.card-swatches');
    if (!list) return;
    if (event.relatedTarget && list.contains(event.relatedTarget)) return;
    var img = cardImageFrom(list);
    if (!img || typeof img.dataset.khOriginalSrc === 'undefined') return;
    img.setAttribute('srcset', img.dataset.khOriginalSrcset || '');
    img.setAttribute('src', img.dataset.khOriginalSrc);
  });
})();
